<template>
	<div>
		<UplimitStep @show_sidebar="show_sidebar"></UplimitStep>
		<StockInfoSidebar :symbol_code="symbol_code"  :symbol_name="symbol_name" :date_mark="date_mark"></StockInfoSidebar>
		
	</div>
</template>

<script>
	import UplimitStep from 'components/uplimit/UplimitStep.vue'
	import StockInfoSidebar from 'components/stock/StockInfoSidebar.vue'

	export default {
		data() {
			return {
				isActive: true,
				symbol_code:'603069',
				symbol_name:'',
				date_mark:''
			}
		},
		components: {
			// SentimentZhaban,
			UplimitStep,
			StockInfoSidebar,
		},
		methods: {
			show_sidebar(stock_info){
				// console.log(stock_info);
				this.symbol_code=stock_info['stock_code'];
				this.symbol_name=stock_info['stock_name'];
				this.date_mark=stock_info['date1'];
			}
		}
	}
</script>

<style>
</style>
